import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hook';

import { onboardingState } from '../../../redux/slices/detSlice';
import { setGuestVerificationLazyLoad } from '../../../redux/slices/sessionSlice';

const CaptureDoc = ({
	docType,
	incode,
	onComplete,
	onCameraStateChange,
	initializeSDK,
}) => {
	const containerRef = useRef(null);

	const [step, setStep] = useState('init'); // current step
	const [msg, setMsg] = useState('Preparing camera...');
	const [isProcessing, setIsProcessing] = useState(false);
	const [hideInstructions, setHideInstructions] = useState(false);
	const { onboardingToken } = useAppSelector(onboardingState);
	const isPassport = docType === 'passport';
	const dispatch = useAppDispatch();
	/* ---------------------------------------------------
	   Auto Start When Component Loads
	--------------------------------------------------- */
	useEffect(() => {
		if (incode && containerRef.current) {
			const start = async () => {
				const success = await initializeSDK();
				if (success) {
					startDocumentFlow();
				}
			};
			start();
		}
	}, [incode, initializeSDK]);

	/* ---------------------------------------------------
	   Shared Camera Renderer
	--------------------------------------------------- */
	const renderIncodeCamera = (side, onSuccessExtra) => {
		onCameraStateChange?.(true);
		// incode.renderCaptureId(side, containerRef.current, {
		incode.renderCaptureId(containerRef.current, {
			showTutorial: true,
			showPreview: false,
			showCustomCameraPermissionScreen: true,
			numberOfTries: 3,
			token: onboardingToken,
			session: { token: onboardingToken },
			timeout: 15000,
			captureConfig: {
				showDocumentChooser: false, // skips "Select what document you want to scan"
				enableId: true, // go straight to the ID front
				enablePassport: false,
				showTutorial: true,
				captureAttempts: 3,
				autoCaptureTimeout: 30, // seconds
				idDetectionTimeout: 500, // seconds
				enableIdRecording: false,
				isSecondId: false,
				onlyBack: false,
				manualUploadIdCapture: false,

				digitalIdsUpload: false,
				usSmartCapture: false,

				ageAssurance: false,
				mergeSessionRecordings: false,
				isDeepsightEnabled: false,
				extractIdFace: true,
			},

			onSuccess: (res) => {
				console.info('Capture Success:', res);
				setHideInstructions(true);
				onCameraStateChange?.(false);
				onSuccessExtra?.();
			},
			onError: (err) => {
				console.error('Capture Error:', err);
				setMsg(
					`${
						side.charAt(0).toUpperCase() + side.slice(1)
					} capture failed. Please try again.`
				);
				onCameraStateChange?.(false);
				onComplete({ success: false, stage: side, error: err });
			},
		});
	};

	/* ---------------------------------------------------
	    Capture Front / Passport
	--------------------------------------------------- */
	const startDocumentFlow = () => {
		const side = isPassport ? 'passport' : 'front';
		setStep(side);
		setMsg(
			isPassport
				? 'Please scan your Passport'
				: 'Please scan the FRONT side of your Emirates ID'
		);

		renderIncodeCamera(side, async () => {
			if (isPassport) {
				// setIsProcessing(true);
				dispatch(setGuestVerificationLazyLoad(true));
				setMsg('Capture complete. Processing...');
				await processId();
			} else {
				// setIsProcessing(false);
				// dispatch(setGuestVerificationLazyLoad(false));
				// captureBack();
				dispatch(setGuestVerificationLazyLoad(true));
				setMsg('Capture complete. Processing...');
				await processId();
			}
		});
	};

	/* ---------------------------------------------------
	   Process ID
	--------------------------------------------------- */
	const processId = async () => {
		setStep('processing-id');
		setMsg('Processing your document...');

		try {
			const result = await incode.processId({
				session: onboardingToken,
				token: onboardingToken,
			});
			console.info('ID Processed:', result);

			if (isPassport) {
				onComplete({ success: true, stage: 'passport' });
			} else {
				onComplete({ success: true, stage: 'back' });
			}
		} catch (err) {
			setMsg('Document processing failed. Please try again.');
			onComplete({ success: false, stage: 'id', error: err });
		}
	};

	return (
		<div
			className={`verification-fullscreen ${
				hideInstructions ? 'hide-incode-instructions' : ''
			}`}
			style={{
				position: 'fixed',
				inset: 0,
				zIndex: 999,
				top: '0px',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100vw',
				height: 'calc(100dvh - 0px)',
				minHeight: 'calc(100vh - 0px)',
				overflow: 'hidden',
				background: '#f5f5f5',
				padding: '0',
				margin: '0',
			}}>
			<div
				ref={containerRef}
				className={`camera-box ${isProcessing ? 'processing' : ''}`}
				style={{
					flex: '1 1 auto',
					width: '100%',
					background: '#000',
				}}
			/>
		</div>
	);
};

export default CaptureDoc;
